"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _Dom = require("../utils/Dom");

var _Controllable = _interopRequireDefault(require("../decorators/Controllable"));

var _SyntheticEvent = _interopRequireDefault(require("../core/SyntheticEvent"));

var _memoizeOne = _interopRequireDefault(require("react-utils/memoizeOne"));

var getClosestTable = function getClosestTable(el) {
  return (0, _Dom.closest)(el, 'TABLE');
};

var getClosestTableRow = function getClosestTableRow(el) {
  return (0, _Dom.closest)(el, 'TR');
};

var bindEventListeners = function bindEventListeners(instance) {
  // Add event listeners to the row and table this component lives in
  var table = getClosestTable(instance._el);
  var tr = getClosestTableRow(instance._el);
  if (!tr || !table) return;
  table.addEventListener('mouseleave', instance.handleRowOrTableMouseLeave);
  tr.addEventListener('mouseleave', instance.handleRowOrTableMouseLeave);
  tr.addEventListener('mouseenter', instance.handleRowMouseEnter);
  tr.addEventListener('focus', instance.handleRowFocus, true);
  tr.addEventListener('blur', instance.handleRowBlur, true); // If the user clicks a control with a mouse, we want to ignore the focus on that control (#3054)

  tr.addEventListener('mouseup', instance.handleRowBlur);
};

var unbindEventListeners = function unbindEventListeners(instance) {
  // Clean up any event handlers we've added to other elements
  var table = getClosestTable(instance._el);
  var tr = getClosestTableRow(instance._el);
  if (!tr || !table) return;
  table.removeEventListener('mouseleave', instance.handleRowOrTableMouseLeave);
  tr.removeEventListener('mouseenter', instance.handleRowMouseEnter);
  tr.removeEventListener('mouseleave', instance.handleRowOrTableMouseLeave);
  tr.removeEventListener('focus', instance.handleRowFocus, true);
  tr.removeEventListener('blur', instance.handleRowBlur, true);
  tr.removeEventListener('mouseup', instance.handleRowBlur);
};

var getStyle = function getStyle(style, top, left) {
  return (0, _extends2.default)({}, style, {
    top: top,
    left: left
  });
};

var UITableHoverContent =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(UITableHoverContent, _PureComponent);

  function UITableHoverContent(props) {
    var _this;

    (0, _classCallCheck2.default)(this, UITableHoverContent);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UITableHoverContent).call(this, props));
    _this.state = {
      top: null,
      left: null,
      rowHasFocus: false,
      rowHasMouse: false,
      rowHasOpenDropdown: false
    };
    _this._getStyle = (0, _memoizeOne.default)(getStyle);
    _this.checkForOpenDropdown = _this.checkForOpenDropdown.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleRowMouseEnter = _this.handleRowMouseEnter.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleRowOrTableMouseLeave = _this.handleRowOrTableMouseLeave.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleRowFocus = _this.handleRowFocus.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleRowBlur = _this.handleRowBlur.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(UITableHoverContent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this._isMounted = true;
      requestAnimationFrame(function () {
        bindEventListeners(_this2);

        _this2.checkForOpenDropdown();

        if (_this2._el) {
          _this2._observer = new MutationObserver(_this2.checkForOpenDropdown);

          _this2._observer.observe(_this2._el, {
            attributes: true,
            childList: true,
            subtree: true
          });
        }
      });
    }
  }, {
    key: "componentWillUpdate",
    value: function componentWillUpdate(nextProps) {
      var open = this.props.open;
      if (!this._isMounted) return; // In shrinkOnHide mode, compute our absolute position before hiding (#2412)

      if (nextProps.shrinkOnHide && open && !nextProps.open) {
        var _this$computeAbsolute = this.computeAbsolutePosition(),
            top = _this$computeAbsolute.top,
            left = _this$computeAbsolute.left;

        if (top !== this.state.top || left !== this.state.left) {
          this.setState({
            top: top,
            left: left
          });
        }
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var onOpenChange = this.props.onOpenChange;
      var _this$state = this.state,
          rowHasFocus = _this$state.rowHasFocus,
          rowHasMouse = _this$state.rowHasMouse,
          rowHasOpenDropdown = _this$state.rowHasOpenDropdown; // These state checks prevent infinite update loops when `open` is controlled.

      if (rowHasFocus !== prevState.rowHasFocus || rowHasMouse !== prevState.rowHasMouse || rowHasOpenDropdown !== prevState.rowHasOpenDropdown) {
        var shouldBeOpen = rowHasFocus || rowHasMouse || rowHasOpenDropdown;
        onOpenChange((0, _SyntheticEvent.default)(shouldBeOpen));
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._isMounted = false;
      unbindEventListeners(this);
      if (this._observer) this._observer.disconnect();
    }
  }, {
    key: "checkForOpenDropdown",
    value: function checkForOpenDropdown() {
      if (!this._el) return;
      var rowHasOpenDropdown = !!this._el.querySelector('[aria-pressed="true"]');

      if (this.state.rowHasOpenDropdown !== rowHasOpenDropdown) {
        this.setState({
          rowHasOpenDropdown: rowHasOpenDropdown
        });
      }
    }
  }, {
    key: "computeAbsolutePosition",
    value: function computeAbsolutePosition() {
      // If we're visible but have shrinkOnHide, compute our absolute position.
      // Applying position: absolute implies display: block, so we set
      // display: block in the initial measurement to prevent discrepancies.
      this._el.classList.add('display-block');

      var _this$_el$getBounding = this._el.getBoundingClientRect(),
          left = _this$_el$getBounding.left,
          top = _this$_el$getBounding.top;

      this._el.classList.remove('display-block'); // This measurement tells us how far position: absolute moves us,
      // with top and left set to 0.


      this._el.classList.add('private-table-hover-content--abs-pos');

      var _this$_el$getBounding2 = this._el.getBoundingClientRect(),
          absLeft = _this$_el$getBounding2.left,
          absTop = _this$_el$getBounding2.top;

      this._el.classList.remove('private-table-hover-content--abs-pos'); // We take the difference between the two measurements as the appropriate
      // top and left values to apply while hidden.


      return {
        left: left - absLeft,
        top: top - absTop
      };
    }
  }, {
    key: "handleRowMouseEnter",
    value: function handleRowMouseEnter() {
      this.setState({
        rowHasMouse: true
      });
    }
  }, {
    key: "handleRowOrTableMouseLeave",
    value: function handleRowOrTableMouseLeave() {
      // Sometimes mouseleave is triggered on the <table> but not the <tr>
      if (this.state.rowHasMouse) {
        this.setState({
          rowHasMouse: false
        });
      }
    }
  }, {
    key: "handleRowFocus",
    value: function handleRowFocus() {
      this.setState({
        rowHasFocus: true
      });
    }
  }, {
    key: "handleRowBlur",
    value: function handleRowBlur() {
      this.setState({
        rowHasFocus: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          __onOpenChange = _this$props.onOpenChange,
          open = _this$props.open,
          shrinkOnHide = _this$props.shrinkOnHide,
          style = _this$props.style,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["children", "className", "onOpenChange", "open", "shrinkOnHide", "style"]);
      var _this$state2 = this.state,
          top = _this$state2.top,
          left = _this$state2.left;
      var computedClassName = (0, _classNames.default)('private-table-hover-content', 'table-hover-content', className, {
        'private-table-hover-content--visible': open,
        'private-table-hover-content--shrink-on-hide': shrinkOnHide
      });
      return _react.default.createElement("span", (0, _extends2.default)({
        className: computedClassName,
        ref: function ref(_ref) {
          _this3._el = _ref;
        },
        style: open || !shrinkOnHide ? style : this._getStyle(style, top, left)
      }, rest), children);
    }
  }]);
  return UITableHoverContent;
}(_react.PureComponent);

UITableHoverContent.propTypes = {
  children: _react.PropTypes.node.isRequired,
  onOpenChange: _react.PropTypes.func,
  open: _react.PropTypes.bool,
  shrinkOnHide: _react.PropTypes.bool.isRequired
};
UITableHoverContent.defaultProps = {
  open: false,
  shrinkOnHide: false
};
UITableHoverContent.displayName = 'UITableHoverContent';

var _default = (0, _Controllable.default)(UITableHoverContent, ['open']);

exports.default = _default;
module.exports = exports.default;